import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export type PaginationFormat = 'show_x_of_y' | 'showing_x_y_of_z';

export default function useTableAction() {
  const { t } = useTranslation();

  const customTitle = useCallback(
    (total: number, range: [number, number], format: PaginationFormat = 'show_x_of_y'): JSX.Element => {
      if (format === 'showing_x_y_of_z') {
        return (
          <span className='text-customTunaPrimary font-bold'>
            <span className='font-medium'>Showing </span>
            {range[0].toLocaleString()}–{range[1].toLocaleString()}
            <span className='font-medium'> of </span>
            {total.toLocaleString()}
          </span>
        );
      }
      return (
        <span className='text-customTunaPrimary font-bold'>
          <span className='font-medium'>{t('show')} </span>
          {range[1].toLocaleString()}/{total.toLocaleString()}{' '}
          <span className='font-medium'>{t('records')}</span>
        </span>
      );
    },
    [t],
  );

  return {
    customTitle,
  };
}
